import React from 'react'
import PropTypes from 'prop-types'
import SummaryItem from './SummaryItem'

export default function Summary(props) {
	return (
		<div className="overview-section">
			<div className="content-wrap">
				<h2>Here&apos;s The Data We Crunched</h2>
				{/* <p className="desc">The following data was used to create this report</p> */}
				{Object.keys(props.summary).map((key, idx) =>
					<SummaryItem key={idx} idx={idx} stat={{key: key, value: props.summary[key]}} />
				)}
			</div>
		</div>
	)
}

Summary.propTypes = {
	summary: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/Summary.js